<template>
  <div class="flex gap-1">
    <div
      v-for="(segment, index) in segments"
      :key="index"
      class="w-6 h-2 rounded overflow-hidden"
      :style="getSegmentStyle(index)"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'SegmentedProgressBar',
  props: {
    progress: {
      type: Number,
      required: true
    },
    totalSegments: {
      type: Number,
      default: 5
    }
  },
  computed: {
    segments() {
      return Array.from({ length: this.totalSegments });
    }
  },
  methods: {
    getSegmentStyle(index) {
      const segmentPercent = 100 / this.totalSegments;
      const filled = this.progress - index * segmentPercent;

      if (filled >= segmentPercent) {
        // Completamente lleno
        return { backgroundColor: '#a2f5bf' }; // Tailwind green-500 22c55e
      } else if (filled > 0) {
        // Parcialmente lleno
        const fillPercent = Math.min(filled / segmentPercent, 1) * 100;
        return {
          background: `linear-gradient(to right, #a2f5bf ${fillPercent}%, #d1d5db ${fillPercent}%)` // gray-300
        };
      } else {
        // Vacío
        return { backgroundColor: '#d1d5db' }; // Tailwind gray-300
      }
    }
  }
};
</script>